import { WidgetBase } from "../core/WidgetBase.js";
import Mustache from 'mustache';

export class HtmlWidget extends WidgetBase {
    constructor(config) {
        super(config);
        this.htmlContent = config.widget.html || ''; 
        this.data = null;
        this._boundClickHandler = this.handleClick.bind(this);
    }

    async renderContent() {
        if (this.error) {
            this.contentContainer.innerHTML = `<div class="widget-error">Error: ${this.error.message}</div>`;
            return;
        }

        if (this.isLoading) return;

        this.contentContainer.removeEventListener('click', this._boundClickHandler);
        this.contentContainer.innerHTML = '';

        const renderedHtml = Mustache.render(this.htmlContent, this.data || {});
        this.contentContainer.innerHTML = renderedHtml;

        this.contentContainer.addEventListener('click', this._boundClickHandler);
        this.appClient.tx.applyTranslations(this.contentContainer);
    }

    handleClick(event) {
        const target = event.target.closest('[data-action]');
        if (!target) return;

        const action = target.dataset.action;

        // 1. Handle Navigation
        if (action === 'navigate') {
            const route = target.dataset.route;
            if (route) {
                event.preventDefault();
                this.appClient.layoutEngine.navigate(route);
            }
        }
        
        // 2. Handle Event Emission (The Generic Solution)
        else if (action === 'emit') {
            const eventName = target.dataset.event;
            if (eventName) {
                let payload = {};
                // Optionally parse a JSON payload if provided
                if (target.dataset.payload) {
                    try {
                        payload = JSON.parse(target.dataset.payload);
                    } catch (e) {
                        this.log.warn(`Invalid JSON payload for event ${eventName}`, e);
                    }
                }
                
                this.log.debug(`HtmlWidget emitting event: ${eventName}`, payload);
                this.appClient.events.fireLocal(eventName, payload);
            }
        }
    }

    destroy() {
        if (this.contentContainer) {
            this.contentContainer.removeEventListener('click', this._boundClickHandler);
        }
        super.destroy();
    }
}